<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CMQMqA/tc-custom/9781398458901.jpg?1680421233859" alt="This image is the cover for the book The Kid From Port Douglas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Kid From Port Douglas
      </h1>
      <p class="bookDescription body article font2">
        <p>You are transported into this huge-hearted girl’s world and gasp at the earthy honesty of a child condemned to a life of hard-working business-owning parents as she goes on to unfold the similarities in her own eventual career and life path. Some of the stories will break the hardest of hearts or produce the heartiest belly laughter. The author has an easy literary style whilst also embracing some controversially high-brow topics, in contrast, emerging as infamous winners of reality TV. Military parade life, travel petty officers and parade grounds, Switzerland, Kensington High Street, Port Douglas, Hotels, Mareeba and Wales. Also some incredible stories of family war heroes; of Changi Prison and the Red Baron. And of Taffy Lloyd, the last man on the beach in Dunkirk. Every page has its own charm, you will consider it a well-chosen book, so curious reader, enjoy.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sandra Penny McCallum
      </h2>
      
      <p class="authorDescription body article">Sandra Penny McCallum, the Australian-born author of this earthy autobiography, calls herself a global gypsy and murmurs jestfully of her current exile in the Algarve of Portugal, having left Australia 20 years ago. This wonderful time and place have inspired the need to write as a catharsis well overdue. This book was inspired by an exhilarating life story and an interest in pre-history, a fascination and study of aspects of the English Renaissance, and some incredible life stories.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?35866996